import { Message } from  'element-ui'

/**
 * 验证字段
 *
 * @export
 * @param {Map} verifyRules
 * ```javascript
 *   {
 *     companyName: [{required: true, message: '请输入企业/机构名称'}],
 *     code: [{validator: (val) => val.length === 18, message: '请输入正确的统一社会信用代码'}],
 *     address: [{required: true, message: '请输入地址'}]
 *   }
 * ```
 * @param {Map} form
 * 被验证的数据
 * @param {Array} [fields=[]]
 *  指定某个些字段验证
 * @returns
 */
export default function verifyField(verifyRules, form, fields = []) {
    let pass = true
    let verifys = {}
    if(fields.length) {
        Object.keys(verifyRules).forEach(key => {
            if(fields.includes(key)) {
                verifys[key] = this.verifys[key]
            }
        })
    }else {
        verifys = verifyRules
    }

    Object.keys(verifys).forEach(key => {
            let val = form[key]
            verifys[key] && verifys[key].forEach(validate => {
            if(
                (validate.required && (val === undefined || String(val).trim() === '')) ||
                (validate.validator && !validate.validator(val)))
            {
                if(pass) {
                    pass = false
                    Message({type: 'error', message: validate.message})
                }
            }
        })
    })
    return pass
}